<template>
  <div class="app-container notify-page">
    <div class="page-heading">
      <div>
        <h2>消息提醒</h2>
        <p>统一配置飞书群提醒、接收人、静默时段和失败重试。</p>
      </div>
    </div>
    <el-tabs v-model="tab" @tab-click="loadTab">
      <el-tab-pane label="提醒规则" name="rules">
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="openRule()">新建规则</el-button>
        </div>
        <el-table v-loading="loading" :data="rules" border size="small">
          <el-table-column prop="name" label="规则名称" min-width="160" />
          <el-table-column label="提醒事件" min-width="160"
            ><template slot-scope="s">{{ eventLabel(s.row.eventCode) }}</template></el-table-column
          >
          <el-table-column label="飞书群" min-width="180"
            ><template slot-scope="s"
              ><el-tag v-for="id in parseIds(s.row.robotIds)" :key="id" size="mini">{{
                robotName(id)
              }}</el-tag></template
            ></el-table-column
          >
          <el-table-column label="提醒对象" min-width="130"
            ><template slot-scope="s">{{
              groupName(s.row.recipientGroupId)
            }}</template></el-table-column
          >
          <el-table-column label="静默时段" width="150"
            ><template slot-scope="s">{{
              s.row.quietEnabled ? s.row.quietStart + " - " + s.row.quietEnd : "不启用"
            }}</template></el-table-column
          >
          <el-table-column label="状态" width="90"
            ><template slot-scope="s"
              ><el-switch v-model="s.row.enabled" @change="quickSaveRule(s.row)"/></template
          ></el-table-column>
          <el-table-column label="操作" width="150" fixed="right"
            ><template slot-scope="s"
              ><el-button type="text" @click="openRule(s.row)">编辑</el-button
              ><el-button type="text" class="danger" @click="removeRule(s.row)"
                >删除</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="接收人组" name="groups">
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="openGroup()"
            >新建接收人组</el-button
          >
        </div>
        <el-table :data="groups" border size="small"
          ><el-table-column prop="name" label="组名" /><el-table-column
            prop="remark"
            label="说明"
          /><el-table-column label="成员数"
            ><template slot-scope="s">{{
              parseMembers(s.row.membersJson).length
            }}</template></el-table-column
          ><el-table-column label="状态"
            ><template slot-scope="s">{{
              s.row.enabled ? "启用" : "停用"
            }}</template></el-table-column
          ><el-table-column label="操作"
            ><template slot-scope="s"
              ><el-button type="text" @click="openGroup(s.row)">编辑</el-button
              ><el-button type="text" class="danger" @click="removeGroup(s.row)"
                >删除</el-button
              ></template
            ></el-table-column
          ></el-table
        >
      </el-tab-pane>
      <el-tab-pane label="飞书机器人" name="robots">
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="openRobot()">添加机器人</el-button>
        </div>
        <el-table :data="robots" border size="small"
          ><el-table-column prop="name" label="名称" /><el-table-column
            label="WebHook"
            min-width="300"
            ><template slot-scope="s">{{
              maskWebhook(s.row.webhookUrl)
            }}</template></el-table-column
          ><el-table-column label="状态"
            ><template slot-scope="s"
              ><el-tag :type="s.row.enabled ? 'success' : 'info'">{{
                s.row.enabled ? "启用" : "停用"
              }}</el-tag></template
            ></el-table-column
          ><el-table-column label="操作" width="190"
            ><template slot-scope="s"
              ><el-button type="text" @click="testRobot(s.row)">测试</el-button
              ><el-button type="text" @click="openRobot(s.row)">编辑</el-button
              ><el-button type="text" class="danger" @click="removeRobot(s.row)"
                >删除</el-button
              ></template
            ></el-table-column
          ></el-table
        >
      </el-tab-pane>
      <el-tab-pane label="发送记录" name="records">
        <div class="filter-container">
          <el-select
            v-model="recordQuery.eventCode"
            placeholder="全部事件"
            clearable
            @change="loadRecords"
            ><el-option
              v-for="e in events"
              :key="e.code"
              :label="e.label"
              :value="e.code"/></el-select
          ><el-select
            v-model="recordQuery.status"
            placeholder="全部状态"
            clearable
            @change="loadRecords"
            ><el-option label="待发送" :value="0"/><el-option label="成功" :value="1"/><el-option
              label="重试中"
              :value="2"/><el-option label="失败" :value="3"
          /></el-select>
        </div>
        <el-table :data="records" border size="small"
          ><el-table-column prop="id" label="ID" width="80" /><el-table-column label="事件"
            ><template slot-scope="s">{{ eventLabel(s.row.eventCode) }}</template></el-table-column
          ><el-table-column prop="bizId" label="业务ID" /><el-table-column label="群机器人"
            ><template slot-scope="s">{{ robotName(s.row.robotId) }}</template></el-table-column
          ><el-table-column label="状态"
            ><template slot-scope="s"
              ><el-tag :type="statusType(s.row.status)">{{
                statusText(s.row.status)
              }}</el-tag></template
            ></el-table-column
          ><el-table-column prop="retryCount" label="重试" width="70" /><el-table-column
            prop="errorMessage"
            label="失败原因"
            min-width="180"
            show-overflow-tooltip
          /><el-table-column label="操作" width="80"
            ><template slot-scope="s"
              ><el-button v-if="s.row.status === 3" type="text" @click="retry(s.row)"
                >重试</el-button
              ></template
            ></el-table-column
          ></el-table
        >
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :total="recordTotal"
          :current-page.sync="recordQuery.page"
          :page-size.sync="recordQuery.pageSize"
          :page-sizes="[10, 20, 30, 50]"
          @current-change="loadRecords"
          @size-change="loadRecords"
        />
      </el-tab-pane>
    </el-tabs>

    <el-drawer title="提醒规则" :visible.sync="ruleVisible" size="520px" :wrapper-closable="false">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="ruleRules"
        label-position="top"
        class="drawer-form"
      >
        <el-form-item label="规则名称" prop="name"
          ><el-input v-model="ruleForm.name" maxlength="40" show-word-limit
        /></el-form-item>
        <el-form-item label="提醒事件" prop="eventCode"
          ><el-select v-model="ruleForm.eventCode" style="width:100%" @change="fillDefaultTemplate"
            ><el-option
              v-for="e in events"
              :key="e.code"
              :label="e.label"
              :value="e.code"/></el-select
        ></el-form-item>
        <el-form-item label="发送到飞书群" prop="robotIdsArray"
          ><el-select v-model="ruleForm.robotIdsArray" multiple style="width:100%"
            ><el-option v-for="r in activeRobots" :key="r.id" :label="r.name" :value="r.id"
          /></el-select>
          <div class="hint">支持同时发送到多个群，每个群独立记录发送结果。</div></el-form-item
        >
        <el-form-item label="@接收人组"
          ><el-select v-model="ruleForm.recipientGroupId" clearable style="width:100%"
            ><el-option
              v-for="g in activeGroups"
              :key="g.id"
              :label="g.name"
              :value="g.id"/></el-select
        ></el-form-item>
        <el-form-item label="超时后首次提醒"
          ><el-input-number v-model="ruleForm.triggerDelaySeconds" :min="0" :step="60" /><span
            class="unit"
            >秒</span
          ></el-form-item
        >
        <el-form-item
          ><el-checkbox v-model="ruleForm.repeatEnabled">未处理时重复提醒</el-checkbox>
          <div v-if="ruleForm.repeatEnabled" class="inline-fields">
            <el-input-number v-model="ruleForm.repeatIntervalSeconds" :min="60" :step="60" /><span
              >秒一次，最多</span
            ><el-input-number v-model="ruleForm.maxRepeatCount" :min="1" :max="50" /><span>次</span>
          </div></el-form-item
        >
        <el-form-item
          ><el-checkbox v-model="ruleForm.quietEnabled">启用静默时段</el-checkbox>
          <div v-if="ruleForm.quietEnabled" class="inline-fields">
            <el-time-select v-model="ruleForm.quietStart" :picker-options="timeOptions" /><span
              >至</span
            ><el-time-select v-model="ruleForm.quietEnd" :picker-options="timeOptions" />
          </div>
          <div class="hint">静默结束后，积压事件逐条补发，不合并摘要。</div></el-form-item
        >
        <el-form-item label="消息标题"><el-input v-model="ruleForm.titleTemplate"/></el-form-item
        ><el-form-item label="消息正文"
          ><el-input v-model="ruleForm.contentTemplate" type="textarea" :rows="7"
        /></el-form-item>
        <el-form-item><el-switch v-model="ruleForm.enabled" active-text="启用规则"/></el-form-item>
        <div class="drawer-actions">
          <el-button @click="ruleVisible = false">取消</el-button
          ><el-button type="primary" :loading="saving" @click="submitRule">保存规则</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-dialog
      :title="robotForm.id ? '编辑飞书机器人' : '添加飞书机器人'"
      :visible.sync="robotVisible"
      width="560px"
      ><el-form :model="robotForm" label-width="100px"
        ><el-form-item label="名称"><el-input v-model="robotForm.name"/></el-form-item
        ><el-form-item label="WebHook"
          ><el-input
            v-model="robotForm.webhookUrl"
            type="textarea"
            :rows="3"
            placeholder="https://open.feishu.cn/open-apis/bot/v2/hook/..."/></el-form-item
        ><el-form-item label="状态"><el-switch v-model="robotForm.enabled"/></el-form-item></el-form
      ><span slot="footer"
        ><el-button @click="robotVisible = false">取消</el-button
        ><el-button type="primary" @click="submitRobot">保存</el-button></span
      ></el-dialog
    >
    <el-dialog
      :title="groupForm.id ? '编辑接收人组' : '新建接收人组'"
      :visible.sync="groupVisible"
      width="720px"
      ><el-form :model="groupForm" label-width="90px"
        ><el-form-item label="组名"><el-input v-model="groupForm.name"/></el-form-item
        ><el-form-item label="说明"><el-input v-model="groupForm.remark"/></el-form-item
        ><el-form-item label="成员"
          ><div v-for="(m, i) in groupForm.members" :key="i" class="member-row">
            <el-input v-model="m.name" placeholder="姓名" /><el-input
              v-model="m.feishuUserId"
              placeholder="飞书 user_id"
            /><el-switch v-model="m.enabled" /><el-button
              type="text"
              class="danger"
              @click="groupForm.members.splice(i, 1)"
              >移除</el-button
            >
          </div>
          <el-button
            type="text"
            icon="el-icon-plus"
            @click="groupForm.members.push({ name: '', feishuUserId: '', enabled: true })"
            >添加成员</el-button
          ></el-form-item
        ><el-form-item label="状态"><el-switch v-model="groupForm.enabled"/></el-form-item></el-form
      ><span slot="footer"
        ><el-button @click="groupVisible = false">取消</el-button
        ><el-button type="primary" @click="submitGroup">保存</el-button></span
      ></el-dialog
    >
  </div>
</template>

<script>
import * as api from "@/api/operationNotify";
export default {
  data() {
    return {
      tab: "rules",
      loading: false,
      saving: false,
      rules: [],
      robots: [],
      groups: [],
      events: [],
      records: [],
      recordTotal: 0,
      ruleVisible: false,
      robotVisible: false,
      groupVisible: false,
      recordQuery: { page: 1, pageSize: 20, eventCode: null, status: null },
      ruleForm: {},
      robotForm: {},
      groupForm: {},
      timeOptions: { start: "00:00", step: "00:30", end: "23:30" },
      ruleRules: {
        name: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        eventCode: [{ required: true, message: "请选择提醒事件", trigger: "change" }],
        robotIdsArray: [
          {
            type: "array",
            required: true,
            min: 1,
            message: "至少选择一个飞书群",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    activeRobots() {
      return this.robots.filter(x => x.enabled);
    },
    activeGroups() {
      return this.groups.filter(x => x.enabled);
    }
  },
  created() {
    this.loadBase();
    this.loadRules();
  },
  methods: {
    async loadBase() {
      const [e, r, g] = await Promise.all([
        api.getNotifyEvents(),
        api.getNotifyRobots(),
        api.getNotifyGroups()
      ]);
      this.events = e.data || [];
      this.robots = r.data || [];
      this.groups = g.data || [];
    },
    loadTab() {
      if (this.tab === "rules") this.loadRules();
      if (this.tab === "robots" || this.tab === "groups") this.loadBase();
      if (this.tab === "records") this.loadRecords();
    },
    async loadRules() {
      this.loading = true;
      try {
        const r = await api.getNotifyRules();
        this.rules = r.data || [];
      } finally {
        this.loading = false;
      }
    },
    async loadRecords() {
      const r = await api.getNotifyRecords(this.recordQuery);
      this.records = (r.data && r.data.entitys) || [];
      this.recordTotal = (r.data && r.data.totalCount) || 0;
    },
    openRule(row) {
      this.ruleForm = Object.assign(
        {
          id: null,
          name: "",
          eventCode: "",
          robotIdsArray: [],
          recipientGroupId: null,
          triggerDelaySeconds: 0,
          repeatEnabled: false,
          repeatIntervalSeconds: 1800,
          maxRepeatCount: 3,
          quietEnabled: false,
          quietStart: "22:00",
          quietEnd: "08:00",
          titleTemplate: "",
          contentTemplate: "",
          enabled: true
        },
        row || {}
      );
      this.ruleForm.robotIdsArray = this.parseIds(this.ruleForm.robotIds);
      this.ruleVisible = true;
    },
    fillDefaultTemplate(code) {
      const e = this.events.find(x => x.code === code);
      if (e && !this.ruleForm.id) {
        this.ruleForm.name = e.label;
        this.ruleForm.titleTemplate = e.defaultTitle;
        this.ruleForm.contentTemplate = e.defaultContent;
      }
    },
    submitRule() {
      this.$refs.ruleForm.validate(async ok => {
        if (!ok) return;
        this.saving = true;
        try {
          const data = Object.assign({}, this.ruleForm, {
            robotIds: JSON.stringify(this.ruleForm.robotIdsArray)
          });
          delete data.robotIdsArray;
          await api.saveNotifyRule(data);
          this.$message.success("保存成功");
          this.ruleVisible = false;
          this.loadRules();
        } finally {
          this.saving = false;
        }
      });
    },
    async quickSaveRule(row) {
      await api.saveNotifyRule(row);
      this.$message.success(row.enabled ? "规则已启用" : "规则已停用");
    },
    async removeRule(row) {
      await this.confirmDelete();
      await api.deleteNotifyRule(row.id);
      this.loadRules();
    },
    openRobot(row) {
      this.robotForm = Object.assign(
        { id: null, name: "", webhookUrl: "", enabled: true },
        row || {}
      );
      this.robotVisible = true;
    },
    async submitRobot() {
      if (!this.robotForm.name || !this.robotForm.webhookUrl)
        return this.$message.warning("请填写名称和 WebHook");
      await api.saveNotifyRobot(this.robotForm);
      this.$message.success("保存成功");
      this.robotVisible = false;
      this.loadBase();
    },
    async testRobot(row) {
      await api.testNotifyRobot(row.id);
      this.$message.success("测试消息已发送");
    },
    async removeRobot(row) {
      await this.confirmDelete();
      await api.deleteNotifyRobot(row.id);
      this.loadBase();
    },
    openGroup(row) {
      this.groupForm = Object.assign(
        { id: null, name: "", remark: "", enabled: true, members: [] },
        row || {}
      );
      this.groupForm.members = this.parseMembers(this.groupForm.membersJson);
      this.groupVisible = true;
    },
    async submitGroup() {
      if (!this.groupForm.name) return this.$message.warning("请输入组名");
      const data = Object.assign({}, this.groupForm, {
        membersJson: JSON.stringify(this.groupForm.members)
      });
      delete data.members;
      await api.saveNotifyGroup(data);
      this.$message.success("保存成功");
      this.groupVisible = false;
      this.loadBase();
    },
    async removeGroup(row) {
      await this.confirmDelete();
      await api.deleteNotifyGroup(row.id);
      this.loadBase();
    },
    async retry(row) {
      await api.retryNotifyRecord(row.id);
      this.$message.success("已进入重试队列");
      this.loadRecords();
    },
    confirmDelete() {
      return this.$confirm("删除后不可恢复，是否继续？", "提示", { type: "warning" });
    },
    parseIds(v) {
      try {
        return Array.isArray(v) ? v : JSON.parse(v || "[]");
      } catch (e) {
        return [];
      }
    },
    parseMembers(v) {
      try {
        return Array.isArray(v) ? v : JSON.parse(v || "[]");
      } catch (e) {
        return [];
      }
    },
    eventLabel(c) {
      const e = this.events.find(x => x.code === c);
      return e ? e.label : c;
    },
    robotName(id) {
      const r = this.robots.find(x => String(x.id) === String(id));
      return r ? r.name : "机器人 #" + id;
    },
    groupName(id) {
      if (!id) return "不 @ 指定人员";
      const g = this.groups.find(x => String(x.id) === String(id));
      return g ? g.name : "接收人组 #" + id;
    },
    maskWebhook(v) {
      if (!v) return "-";
      return v.length > 38 ? v.slice(0, 30) + "••••••" + v.slice(-8) : v;
    },
    statusText(s) {
      return ["待发送", "成功", "重试中", "失败"][s] || "未知";
    },
    statusType(s) {
      return ["info", "success", "warning", "danger"][s] || "info";
    }
  }
};
</script>
<style lang="scss" scoped>
.notify-page {
  .page-heading {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }
  h2 {
    margin: 0 0 6px;
    font-size: 22px;
    color: #1f2937;
  }
  p {
    margin: 0;
    color: #8492a6;
  }
  .toolbar {
    margin-bottom: 14px;
  }
  .danger {
    color: #f56c6c;
  }
  .el-tag {
    margin-right: 6px;
  }
  .el-pagination {
    margin-top: 18px;
    text-align: right;
  }
  .filter-container .el-select {
    margin-right: 10px;
  }
  .drawer-form {
    padding: 0 28px 88px;
  }
  .drawer-actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 14px 28px;
    text-align: right;
    border-top: 1px solid #ebeef5;
    background: #fff;
  }
  .hint {
    font-size: 12px;
    line-height: 20px;
    color: #909399;
  }
  .unit {
    margin-left: 8px;
  }
  .inline-fields {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-top: 10px;
  }
  .member-row {
    display: grid;
    grid-template-columns: 150px 1fr 46px 44px;
    gap: 10px;
    margin-bottom: 10px;
  }
}
</style>
